<template>
  <b-card class="mb-5 py-8 px-8 sor-header" no-body>
    <slot name="header"></slot>

    <div class="center-v">
      <div
        v-for="(item, i) in config"
        class="sor-statistic d-flex flex-row align-items-center"
        :class="{
          [item.wrapperClass ? item.wrapperClass : '']: true,
        }"
        :key="'header-statistic' + i"
      >
        <div class="icon-wrapper px-2">
          <img
            :src="require(`../../../static/img/icon/${item.icon ? item.icon : 'so'}.svg`)"
          />
        </div>

        <div>
          <small class="d-block">{{ item.label }}</small>
          <p class="text-no-wrap mb-0 pb-0">
            <span
              :class="{
                [item.prependClass ? item.prependClass : '']: true,
              }"
            >
              {{ item.prepend }}
            </span>
            <span
              :class="{
                [item.class ? item.class : '']: true,
              }"
              >{{ getter(item.value) | parse(item.transform || "default") }}
            </span>
            <span
              v-if="item.append"
              :class="{
                [item.appendClass ? item.appendClass : '']: true,
              }"
              >{{ item.append }}</span
            >
          </p>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "inline-filter",
  props: {
    data: {
      required: false,
      default: () => {},
    },
    config: {
      required: false,
      default: () => [],
    },
  },

  methods: {
    getter(value) {
      if (typeof value !== "string") return "";
      var valueArr = value.split(".");
      var toReturn = this.data;
      for (const keys of valueArr) {
        toReturn = toReturn[keys];
      }

      return toReturn;
    },
  },
};
</script>

<style scoped>
.sor-statistic {
  background: #f3f6f9;
  border-radius: 8px;
  margin-right: 1em;
  padding: 1em 2em 1em 1em;
}

.sor-statistic.bg-success {
  background: #c9f7f5 !important;
}

.sor-statistic.bg-danger {
  background: #ffe2e5 !important;
}

.sor-header {
  overflow-x: scroll;
}

.sor-statistic .icon-wrapper {
  margin-right: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/base/component/header-statistic.vue